/**
 * This file is part of Paper Shaders for Gutenberg.
 *
 * Paper Shaders for Gutenberg is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 2 of the License, or any later version.
 *
 * Paper Shaders for Gutenberg is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * Paper Shaders for Gutenberg.  If not, see <https://www.gnu.org/licenses/>.
 */

import { HalftoneCmyk, halftoneCmykPresets } from '@paper-design/shaders-react';

const { worldWidth, worldHeight, ...defaults } = halftoneCmykPresets[0].params;

export default function Shader( {
	image,
	colorBack,
	colorC,
	colorM,
	colorY,
	colorK,
	size,
	gridNoise,
	type,
	softness,
	contrast,
	floodC,
	floodM,
	floodY,
	floodK,
	gainC,
	gainM,
	gainY,
	gainK,
	grainSize,
	grainMixer,
	grainOverlay,
	scale,
	fit,
} ) {
	return <HalftoneCmyk
		image={ image }
		worldWidth={ worldWidth }
		worldHeight={ worldHeight }
		colorBack={ colorBack ?? defaults.colorBack }
		colorC={ colorC ?? defaults.colorC }
		colorM={ colorM ?? defaults.colorM }
		colorY={ colorY ?? defaults.colorY }
		colorK={ colorK ?? defaults.colorK }
		size={ parseFloat( size ?? defaults.size.toString() ) }
		gridNoise={ parseFloat( gridNoise ?? defaults.gridNoise.toString() ) }
		type={ type ?? defaults.type }
		softness={ parseFloat( softness ?? defaults.softness.toString() ) }
		contrast={ parseFloat( contrast ?? defaults.contrast.toString() ) }
		floodC={ parseFloat( floodC ?? defaults.floodC.toString() ) }
		floodM={ parseFloat( floodM ?? defaults.floodM.toString() ) }
		floodY={ parseFloat( floodY ?? defaults.floodY.toString() ) }
		floodK={ parseFloat( floodK ?? defaults.floodK.toString() ) }
		gainC={ parseFloat( gainC ?? defaults.gainC.toString() ) }
		gainM={ parseFloat( gainM ?? defaults.gainM.toString() ) }
		gainY={ parseFloat( gainY ?? defaults.gainY.toString() ) }
		gainK={ parseFloat( gainK ?? defaults.gainK.toString() ) }
		grainMixer={ parseFloat( grainMixer ?? defaults.grainMixer.toString() ) }
		grainOverlay={ parseFloat( grainOverlay ?? defaults.grainOverlay.toString() ) }
		grainSize={ parseFloat( grainSize ?? defaults.grainSize.toString() ) }
		fit={ fit ?? defaults.fit }
		scale={ parseFloat( scale ?? defaults.scale.toString() ) }
	/>
}
